export const zoomModes = {
    addNew: 'AddNew',
    advancedSearch: 'Query',
    fieldValue: 'FieldValue'
};
